import React from 'react';
import {useIntl} from 'react-intl';
import moment from 'moment';

import PropTypes from 'prop-types';
import {List, Avatar, Modal, Comment, Tooltip} from 'antd';
import './NotificationItem.less';

const NotificationItem = (props) => {
  const {item} = props;
  const intl = useIntl();

  const onDetail = () => {
    Modal.info({
      title: intl.messages['common.detail'],
      content: (
        <Comment
          author={item.name}
          avatar={<Avatar src={item.image} alt={item.name} />}
          content={
            <p>
              <div
                dangerouslySetInnerHTML={{
                  __html: item.message,
                }}
              />
            </p>
          }
          datetime={
            <Tooltip title={item.time}>
              <span>{moment(item.time, 'DD/MM/YYYY HH:mm:ss').fromNow()}</span>
            </Tooltip>
          }
        />
      ),
      onOk() {},
    });
  };

  return (
    <List.Item className='notify-listItem item-hover'>
      <List.Item.Meta
        avatar={
          item.image ? (
            <Avatar
              className='notify-message-avatar'
              src={item.image}
              alt={item.name}
            />
          ) : (
            ''
          )
        }
        title={
          <a onClick={() => onDetail()}>
            {item.name} - {moment(item.time, 'DD/MM/YYYY HH:mm:ss').fromNow()}
          </a>
        }
        description={
          <a onClick={() => onDetail()}>
            <div
              dangerouslySetInnerHTML={{
                __html: item.message,
              }}
            />
          </a>
        }
      />
    </List.Item>
  );
};

export default NotificationItem;

NotificationItem.propTypes = {
  item: PropTypes.object.isRequired,
};
